"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToPackageCardProps({ data, mappers, packages, }) {
    let pkg = null;
    if (!('blockType' in data)) {
        pkg = data;
    }
    else if (data.packageCardReference &&
        typeof data.packageCardReference === 'object') {
        pkg = data.packageCardReference;
    }
    else {
        return {};
    }
    const modal = pkg?.modal &&
        mappers.mapBlock({
            mappers,
            packages,
            block: {
                blockType: 'modal',
                modalReference: pkg.modal,
            },
        });
    const content = pkg.mainContent &&
        mappers.mapRichText({ richText: pkg.mainContent, mappers });
    let image;
    if ((pkg.image && typeof pkg.image === 'object', pkg.image?.length)) {
        image = mappers.mapBlock({
            block: pkg.image[0],
            mappers,
            inHero: true,
        });
    }
    const packageData = pkg?.brandy
        ? packages?.[pkg.brandy]
        : null;
    if (!packageData) {
        throw new Error(`Package Card Error: brandyPackage is missing for package card for brandy id: ${pkg.brandy} `);
    }
    const label = packageData?.labelOffer || pkg.label || null;
    const layout = pkg.horizontal ? 'Horizontal' : 'Default';
    return {
        label,
        packageData,
        modal,
        layout,
        image,
        content,
    };
}
exports.default = mapToPackageCardProps;
